<div class="min-h-screen bg-gray-100 p-6">
  <h1 class="text-3xl font-bold text-gray-800 mb-6">Reports</h1>
  
  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
   
    <!-- Task Completion Report Card -->
    <div class="bg-white shadow-lg rounded-lg overflow-hidden">
      <div class="p-6">
        <h2 class="text-xl font-semibold text-gray-800 mb-2">Task Completion Report</h2>
        <p class="text-gray-600 mb-4">View detailed data on task completions for the selected period.</p>
        <a class="text-blue-500 hover:underline">Run Report</a>
      </div>
    </div>

    <div class="bg-white shadow-lg rounded-lg overflow-hidden">
      <div class="p-6">
        <h2 class="text-xl font-semibold text-gray-800 mb-2">Day End Reporting</h2>
        <p class="text-gray-600 mb-4">Submit your day end totals here</p>
        <a routerLink="/reports/day-end" class="text-blue-500 hover:underline">Submit A Report</a>
      </div>
    </div>

   
  </div>
</div>


